import { render } from "./TravelPassPaymentConfirmation.vue?vue&type=template&id=17565b9c&lang=pug"
import script from "./TravelPassPaymentConfirmation.vue?vue&type=script&lang=ts"
export * from "./TravelPassPaymentConfirmation.vue?vue&type=script&lang=ts"
script.render = render

export default script